// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkCompanyUserModal_link__KrFus","helperText":"LinkCompanyUserModal_helperText__3BktW"};